/**
 * TODO(release-brief): Replace temporary TTS + muted guide video with a dedicated
 * Ashley Release Brief video that includes synchronized narration audio.
 */

/** Temporary hard-coded narration — must match the Release Brief on-screen copy. */
export const TEMPORARY_RELEASE_BRIEF_NARRATION = [
  "Welcome back.",
  "We've made a few improvements since your last visit.",
  "Navigation has been redesigned.",
  "You can now tap me for voice commands, press and hold for the Quick Menu, and access every feature from the new All Modules button.",
  "When you're ready, press Continue.",
].join(" ");
